import React from 'react';

import { CouldNotGetCardDetailsErrorCard } from '@/components/error/ErrorCard';
import LoaderWithText from '@/components/loading/LoaderWithText';
import { useCreditCardAccount } from '@/domain/account';
import { useCreditCardDetails } from '@/domain/card';
import useText from '@/hooks/use-text';

import { CardBalancePanel, TransactionsList } from './components';

export const KbTransactions = () => {
    const cardQuery = useCreditCardDetails();
    const accountQuery = useCreditCardAccount();
    const text = useText();

    if (cardQuery.isError || accountQuery.isError) {
        return (
            <CouldNotGetCardDetailsErrorCard
                tryAgainClick={() => {
                    if (cardQuery.isError) {
                        cardQuery.refetch();
                    }
                    if (accountQuery.isError) {
                        accountQuery.refetch();
                    }
                }}
                errorMessageText={text.cardInformationFetchErrorMessage}
            />
        );
    }

    if (cardQuery.isLoading || accountQuery.isLoading) {
        return <LoaderWithText title="Laster kort..." />;
    }

    if (cardQuery.isPending || accountQuery.isPending) {
        return null;
    }

    return (
        <div className="sgw-layout seven-four-container">
            <div className="sgw-layout-item seven">
                <div className="sgw-layout-item">
                    <CardBalancePanel card={cardQuery.data} account={accountQuery.data} />
                </div>
                <div className="sgw-layout-item">
                    <TransactionsList />
                </div>
            </div>
        </div>
    );
};
